/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState_hawb = [
    {
        id: '',
        il_air_export_id: '',
        hawb: '',
        il_trade_partner_id_shipper: '',
        il_trade_partner_id_consignee: '',
        hawb_link: '',
        pre_alert: '',
        invoice: 'Pending',
        invoice_link: [],
        invoice_date: null,
        crdr: 'Pending',
        crdr_link: [],
        crdr_date: null,
    },
];

const aexHblUpdateSlice = createSlice({
    name: 'aexHblUpdateForm',
    initialState: initialState_hawb,
    reducers: {
        setHblFormData: (state, action) => {
            return action.payload;
        },
        setHblUpdateData: (state, action) => {
            const { id, newData } = action.payload;
            return state.map((item) => {
                if (item.id === id) {
                    return { ...item, ...newData };
                }
                return item;
            });
        },
        addHBL: (state, action) => {
            addUniqueById(state, action.payload);
        },
        deleteHBL: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((hbl) => hbl.id !== idToDelete);
        },
    },
});

export const { setHblFormData, setHblUpdateData, addHBL, deleteHBL } = aexHblUpdateSlice.actions;
export default aexHblUpdateSlice.reducer;
